import { retrieveSuppliers as apiRetrieveSuppliers } from '@/api/api'

export default {

  RETRIEVE_SUPPLIERS: ({ commit }) => {
    return apiRetrieveSuppliers().then(responseData => {
      commit('SET_SUPPLIERS', { suppliers: responseData.response.data })
    }).catch(error => Promise.reject(error.response.data))
  }
}
